export default function initFormActiveState() {
  // Listen for focus events on all input elements inside forms with the 'gform' class
  document
    .querySelectorAll(
      ".gform_wrapper input, .gform_wrapper select, .gform_wrapper textarea"
    )
    .forEach((input) => {
      input.addEventListener(
        "focus",
        function () {
          // Travel up the DOM tree to find the closest '.gfield' parent
          let parent = this.closest(".gfield");
          if (parent) {
            // Toggle the 'active' class on the '.gfield' parent
            parent.classList.toggle("active");
          }
        },
        true
      ); // Use capture to ensure the event is captured during the capturing phase

      // Also handle blur event to remove 'active' class when input loses focus
      input.addEventListener(
        "blur",
        function () {
          let parent = this.closest(".gfield");
          if (parent) {
            parent.classList.remove("active");
          }
        },
        true
      );
    });
}
